import { ListEvaluationComponent } from './../evaluation-abonnee/components/list-evaluation/list-evaluation.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EvaluationSentComponent } from './evaluation-sent/evaluation-sent.component';
import { TemplateEvaluationClientComponent } from './template-evaluation-client/template-evaluation-client.component';
import { QuestionQuizComponent } from './question-quiz/question-quiz.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'reçus',
    pathMatch: 'full',
  },
  {
    path: 'reçus',
    component: ListEvaluationComponent,
  },
  {
    path: 'evaluations-envoyees',
    component: EvaluationSentComponent,
  },
  {
    path: 'template-evaluation',
    component: TemplateEvaluationClientComponent,
  },
  {
    path: 'quiz',
    component: QuestionQuizComponent,
  },
  {
    path: 'template-eval',
    component: TemplateEvaluationClientComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EvaluationClientRoutingModule {}
